module.exports = __webpack_public_path__ + "img/ipad.940ed173.png";